import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  deleteContainerImportDischarge,
  getAllContainerImportDischarge,
} from "./services/containerImportDischarge.services";
import {
  clearFilterCustomCID,
  clearContainerImportDischargeGUID,
  setFilterCustomCID,
  setContainerImportDischargeGUID,
} from "./containerImportDischargeSlice";
// import { checkAcessRights } from "../../_helper/helper";
// import {
//   DELETE_ACCESS,
//   EDIT_ACCESS,
//   INSERT_ACCESS,
// } from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import _debounce from "lodash/debounce";
import { TextBox } from "@progress/kendo-react-inputs";
import { filterClearIcon } from "@progress/kendo-svg-icons";
const ContainerImportDischarge: React.FC = () => {
  const navigate = useNavigate();
  // const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  const handleCreate = () => {
    navigate("/containerimportdischarge/create");
  };

  return (
    <>
      <DeleteContainerImportDischargeDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Container Import Discharge List
          </Typography.h4>
          {/* {isAddAccess && ( */}
          <Button
            onClick={handleCreate}
            fillMode={"solid"}
            themeColor={"primary"}
          >
            {"Add New"}
          </Button>
          {/* )} */}
        </GridLayoutItem>
        <GridLayoutItem>
          <ContainerImportDischargeGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ContainerImportDischargeGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  // const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const ContainerImportDischargeList = useAppSelector(
    (state) => state.containerImportDischarge.ContainerImportDischargeList
  );
  const loading = useAppSelector((state) => state.containerImportDischarge.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomCID: any = useAppSelector(
    (state) => state.containerImportDischarge.FilterCustomCID
  );

  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      if (!isEditBtnRef.current) {
        dispatch(clearFilterCustomCID());
      }
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterCustomCID,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllContainerImportDischarge(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (container_vessels_guid: number) => {
      navigate("/containerimportdischarge/edit", {
        state: { container_vessels_guid: container_vessels_guid },
      });
    };
    const handleOpenDeleteDialog = (container_vessels_guid: string) => {
      dispatch(openDialog("deleteContainerImportDischarge"));
      dispatch(setContainerImportDischargeGUID(container_vessels_guid));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          ref={isEditBtnRef}
          onClick={() => {
            isEditBtnRef.current = true;
            handleEdit(props.dataItem?.container_vessels_guid);
          }}
        >
          <FiEdit className="absolute-position" style={{ fontSize: "20px" }} />
        </IconButton>
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          onClick={() => handleOpenDeleteDialog(props.dataItem?.container_vessels_guid)}
        >
          <MdDelete
            className="absolute-position"
            style={{ fontSize: "24px" }}
          />
        </IconButton>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleEditCell = (container_vessels_guid: number) => {
    navigate("/containerimportdischarge/edit", {
      state: { container_vessels_guid: container_vessels_guid },
    });
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={
          filter
            ? filterBy(ContainerImportDischargeList, filter)
            : ContainerImportDischargeList
        }
        onFilterChange={handleFilterChange}
        total={
          ContainerImportDischargeList[0]?.item_count ||
          ContainerImportDischargeList.length
        }
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >

        <Column field="eta" title="ETA" cell={(props: any) => (
          <td className="hoverableName" onClick={() => {
            isEditBtnRef.current = true;
            handleEditCell(props.dataItem?.container_vessels_guid);
          }}>
            {props.dataItem?.eta}
          </td>
        )} />

        <Column
          field="vessels_name"
          title="Vessel's Name"
          filterable
          filterCell={CommonFilterCell}
        />
        <Column field="vcn_no" title="VCN No" />
        <Column field="agent_name" title="Agents" />
        <Column field="cargo" title="Cargo" />
        {/* {(isEditAccess || isDeleteAccess) && ( */}
        <Column
          field="id"
          title="Actions"
          cell={MyEditCommandCell}
          width={"140px"}
          filterable={false}
        />
        {/* )} */}
      </KendoGrid>
    </>
  );
};

const DeleteContainerImportDischargeDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ContainerImportDischargeGUID = useAppSelector(
    (state) => state.containerImportDischarge.ContainerImportDischargeGUID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const handleDeleteAction = async (ID: string) => {
    if (ID) {
      const response = await dispatch(deleteContainerImportDischarge(ID));
      const payload = {
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllContainerImportDischarge(payload));
        dispatch(closeDialog());
        dispatch(clearContainerImportDischargeGUID());
      } else {
        dispatch(getAllContainerImportDischarge(payload));
        dispatch(closeDialog());
        dispatch(clearContainerImportDischargeGUID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteContainerImportDischarge" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Container Import Discharge"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Container Import Discharge?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ContainerImportDischargeGUID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomCID: any = useAppSelector(
    (state) => state.containerImportDischarge.FilterCustomCID
  );
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        limit: +pageLimit,
        skip: 0 * +pageLimit,
      };

      dispatch(getAllContainerImportDischarge(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = { ...FilterCustomCID, [inputField]: inputValue };
      dispatch(setFilterCustomCID(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterCustomCID, [props.field]: "" };
    dispatch(setFilterCustomCID(updatedFilters));

    const payload = {
      ...updatedFilters,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };

    dispatch(getAllContainerImportDischarge(payload));
  };
  return (
    <div className="d-flex">
      <TextBox
        value={FilterCustomCID[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterCustomCID[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default ContainerImportDischarge;
